module.exports = __webpack_public_path__ + "img/instances-background.62eadc21.png";